var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('h3',{staticClass:"mm-color mb-3"},[_vm._v("Die neuen Preise ab 01.04.2020")]),_c('img',{attrs:{"src":require("../../assets/Preise_ab_01.04.20.jpg"),"alt":"Neue Preise"}})])
}]

export { render, staticRenderFns }